import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import { customFilter } from '@core/mixins/filters'
import { useResponseRouting } from '@/auth/routeControl'
import { getInternal } from '@/auth/utils'
import axios from '@axios'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'
import '@/libs/common-directive'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'
import '@/libs/vue2-datepicker'
import '@/libs/bootstrap-vue-component'
import '@/libs/custom-quill-editor'
import '@/libs/vue-dompurify-html'

// 보안 관련 추가
useResponseRouting(axios, router)

// Custom Global Filter 정의
Vue.mixin(customFilter)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// 화면 로드 시 GC메디아이 사내망 (사내 외부망 + 사내 내부망) 여부 전역 변수로 설정
getInternal().then(rs => {
  if (rs.success) {
    Vue.prototype.$internal = rs.data
  } else {
    Vue.prototype.$internal = false
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
